import * as React from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { Card, CardHeader, Divider, Grid, List, ListItem } from "@mui/material";

export interface SmartfieldDialogProps {
  open: boolean;
  autolist: any;
  onClose: (value?: any) => void;
}

export default function SmartfieldDialog(props: SmartfieldDialogProps) {
  const { onClose, autolist, open, ...other } = props;

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose("OK");
  };

  return (
    <Dialog sx={{ "& .MuiDialog-paper": { width: "85%", maxHeight: 435 } }} maxWidth="xs" open={open} {...other}>
      <DialogContent sx={{ padding: 0 }}>
        <Card sx={{ padding: 0.5, margin: 1 }} elevation={0}>
          <CardHeader
            sx={{ margin: 0, padding: 0 }}
            subheaderTypographyProps={{ color: "#1C39BB" }}
            subheader="Smart fields"
          ></CardHeader>
          <Divider />
          <List
            dense
            sx={{
              width: "100%",
              position: "relative",
              overflow: "auto",
            }}
          >
            {autolist.map((item, index) => (
              <ListItem sx={{ margin: "0 px", padding: "0 px" }} divider disablePadding={true} key={index}>
                <Grid>
                  <Grid item xs={12}>
                    Name: {item.name}
                  </Grid>
                  <Grid item xs={12}>
                    Doc: {item.docvalue}
                  </Grid>
                  <Grid item xs={12}>
                    Saleforce: {item.sfvalue}
                  </Grid>
                </Grid>
              </ListItem>
            ))}
          </List>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
